import type { TicketPriority } from '../enums/ticket-priority';
import type { TicketStatus } from '../enums/ticket-status';

/**
 * Évènements diffusés par le serveur via WebSocket vers les clients.
 * Le client n'émet pas — auth + abonnement implicite par room utilisateur.
 */
export const RealtimeEvent = {
  TICKET_CREATED: 'ticket.created',
  TICKET_UPDATED: 'ticket.updated',
  MESSAGE_CREATED: 'message.created',
  NOTIFICATION_CREATED: 'notification.created',
} as const;

export type RealtimeEvent = (typeof RealtimeEvent)[keyof typeof RealtimeEvent];

export interface TicketCreatedEvent {
  type: typeof RealtimeEvent.TICKET_CREATED;
  ticketId: string;
  publicId: string;
  subject: string;
  status: TicketStatus;
  priority: TicketPriority;
  requesterId: string;
}

export interface TicketUpdatedEvent {
  type: typeof RealtimeEvent.TICKET_UPDATED;
  ticketId: string;
  publicId: string;
  changes: Partial<{
    status: TicketStatus;
    priority: TicketPriority;
    assigneeId: string | null;
    categoryId: string | null;
  }>;
}

export interface MessageCreatedEvent {
  type: typeof RealtimeEvent.MESSAGE_CREATED;
  ticketId: string;
  messageId: string;
  isInternal: boolean;
  authorId: string;
}

export interface NotificationCreatedEvent {
  type: typeof RealtimeEvent.NOTIFICATION_CREATED;
  notificationId: string;
  userId: string;
  notifType: string;
  title: string;
}

export type RealtimePayload =
  | TicketCreatedEvent
  | TicketUpdatedEvent
  | MessageCreatedEvent
  | NotificationCreatedEvent;
